import { IconButton, Modal } from "@material-ui/core";
import React, {  useCallback, useEffect,  useRef,  useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import errorHandler from "../utils/errorHandler";
import '../../styles/style.scss';
import { swalCustomButtons } from "../utils/handleFunctions";
import Swal from "sweetalert2";
import { timeSessionDifference } from "../../constants/auth/timeSessionDifference";
import { sesionExpired } from "../../constants/auth/sesionExpired";
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import { SET_CLIENT_DATA } from "../../actions/type";

function PaymentModal({
  storedClass,
  formData,
  paramsState = {},
  onSubmit,
  setOpenModalPayment,
  openModalPayment,
  path=null,
  downloadFileByPayment=null,
}) {
  const [isLoading , setIsLoading] = useState(false)
  const [isLoadingPayment, setIsLoadingPayment] = useState(false)

  const [showIfrmae, setShowingIframe] = useState(false)
  const [, setInputData] = useState([])
  // const formRef = useRef(null)
   const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
      const sessionDifference = timeSessionDifference();
    
      

  const dispatch = useDispatch();
  const debounceRef= useRef(null)
  const { clientData,isLoading:isDownloadFile, } = useSelector((state) => state.bancos);
  
    const handleClose = useCallback(() => {
      if(!showIfrmae){ 
        setOpenModalPayment(false)
        setShowingIframe(false)
        
        dispatch({type:SET_CLIENT_DATA, payload:{...clientData, billNumberMap:[]}});
        onSubmit(null, null, paramsState.params)
        
      }else{
         if (debounceRef.current) {
    clearTimeout(debounceRef.current);
  }
  setIsLoading(true)
  debounceRef.current = setTimeout(() => {

    dispatch({
      type: "ALREADY_PAID",
      payload: [...clientData.billNumberMap],
    });
    setIsLoading(false)
    setOpenModalPayment(false);
    setShowingIframe(false);
    onSubmit(null, null, paramsState.params);
  }, 5000);
      }
    }, [setOpenModalPayment, setShowingIframe, onSubmit, paramsState?.params, clientData, dispatch, showIfrmae]);
  useEffect(()=>{
    if(storedClass)setInputData(()=>storedClass?.getFormFields(clientData))
    },[clientData, storedClass])

  useEffect(() => {
    if(showIfrmae && path === "/advance"){
      setOpenModalPayment(false)
      setShowingIframe(false)
      window.location.reload();
    }

  },[showIfrmae, path, setOpenModalPayment, setShowingIframe]);

    /**
   * Save payment
   * Funcion que almacena los datos que se enviaran al banco
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 - Almacenar pagos
   */
  const savePaymentRequest = async()=>{
    
    try{
      const response = await storedClass.savePaymentRequest(clientData, clientData.an8)
      if(response.success){
          if(clientData)setInputData(()=>storedClass.getFormFields(clientData))
        return true
      }
      return true
    }catch (error) {
      console.log(error)
      errorHandler(error, "Error en la solicitud.",history, dispatch)
    }
  }; 
    /**
   * Handle close
   * Cancela pagos
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 - Cancelar pagos
   */
  
  const handleCancel = async () => {
    setIsLoading(true)
    let response
    setOpenModalPayment(false)
     swalCustomButtons.fire({
          title: "¿Está seguro de cancelar el pago?",
          text: "Esta acción borrará el registro del pago.",
          icon: 'warning',
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
           if(result.isConfirmed){
            try {
               dispatch({type:SET_CLIENT_DATA, payload:{...clientData, billNumberMap:[]}});
              switch(path){
                case '/payment':{
                  response = storedClass.cancelPaymentRequest(formData,clientData.an8 ).then((res)=>{
                    if(res.success){
                      dispatch({type:SET_CLIENT_DATA, payload:{...clientData, billNumberMap:[]}});                    
                      setOpenModalPayment(false)
                      setShowingIframe(false)
                       Swal.fire({
                                            icon: 'success',
                                            title: 'Pago cancelado',
                                            text: 'Su pago ha sido cancelado exitosamente.',
                                            showConfirmButton: true,
                                            confirmButtonText: 'Aceptar'
                                          }) 
                    }
                  })
                }break; 
                case '/advance' :{
                  response = storedClass.cancelAdvancePaymentRequest(formData, clientData.an8).then((res)=>{
                    if(res.success){
                      setOpenModalPayment(false)
                      setShowingIframe(false)
                      Swal.fire({
                        icon: 'success',
                        title: 'Pago cancelado',
                        text: 'Su pago ha sido cancelado exitosamente.',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                      }) 
                    }
                  })
                }break;
                default:
                  return 
              }
               
              if(response.success) {
                setOpenModalPayment(false); 
                setShowingIframe(false)
                ; // Recargar la página para reflejar los cambios
              }
            } catch (error) {
              setOpenModalPayment(false);
              errorHandler(error, "Error en la solicitud.",history, dispatch)
            }finally{
              setIsLoading(false)
        
              
              setShowingIframe(false)
            }
           }else{
            setOpenModalPayment(true)
            setShowingIframe(false)
            setIsLoading(false)
           }
        })
  };

   /**
   * Handle submit
   * Funcion que redireccionara al usuario para realizar el pago, se analiza el metodo que se quiera utilizar
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Enero 2025 - Handle submit form bank
   */
  const handleSubmit = async (event)=>{
    setIsLoadingPayment(true)
    event.preventDefault();
    try{
      await savePaymentRequest();
    await storedClass?.executePayment(clientData)
      setShowingIframe(true)
     
    }catch(error) {
      if (error.response) {
            if (sessionDifference > Number(tokenExpired)) {
              sesionExpired(dispatch, history); 
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al procesar la solicitud.',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
              });
            }
          } else {
            actionErrorConnection(error,  'Error de conexión.');
          }
          setShowingIframe(false)
     
    }finally{
      setIsLoadingPayment(false)
      
    }
        
    //formRef.current.submit()
  }
    /**
     * Genera la descarga del archivo
     * @param {Object} detail - detalle de las facturas a recuperar
     * @author Kenzo Sashida - ETE
     * @version 1.0.0 - Enero 2025
     */
  const handleDownload = (formData)=>{
     downloadFileByPayment(formData)
  }

  return (
    <Modal open={openModalPayment} onClose={handleClose} aria-labelledby="modal-multipagos" className="overflow-auto">
      <div className="custom-modal-position p-4 ">
                <IconButton
                    style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                    }}
                    onClick={handleClose}
                    >
                    <i className="far fa-times-circle "></i>
                </IconButton>
        <div className="container">
          { !showIfrmae && 
          
            <div className="row">
          <div className="col-12 d-flex justify-content-center mb-2 align-items-center">
            <span className="icon-container d-flex align-items-center justify-content-center me-3">
              <i className="fas fa-exclamation custom-icon-alert"></i>
            </span>
          </div>
            <div className="col-12 d-flex justify-content-center mb-1 mt-3">
              <span className="text-modal-title font-weight-bold">
                Iniciando proceso de pago...
              </span>
            </div>
            <div className="col-12 d-flex justify-content-center mb-1">
              <span className="d-block text-modal">
                Se abrirá una nueva ventana para realizar el pago.
              </span>
              
            </div>
            <div className="col-12 d-flex justify-content-center mb-4">
            <span className="d-block  font-weight-bold h5 text-wrap">
                No cierre esta ventanta hasta finalizar el proceso.
               
              </span>
              
            </div>
          </div>
          }
          {
            showIfrmae &&
          <div className="row">
          <div className="col-12 d-flex justify-content-center mb-2 align-items-center">
            <span className="icon-container d-flex align-items-center justify-content-center me-3">
              <i className="fas fa-exclamation custom-icon-alert"></i>
            </span>
          </div>
            <div className="col-12 d-flex justify-content-center mb-1 mt-1">
              <span className="text-modal-title font-weight-bold">
                Su pago ha sido redireccionado a la plataforma de pagos {storedClass?.name === "bajio" ? "Bajío" : storedClass?.name}.
              </span>
            </div>
            <div className="col-12 d-flex justify-content-center mb-1">
              <span className="d-block font-weight-bold h5 ">
             
             { isLoading  ?   <i className="fas fa-spinner fa-spin "  style={{ color: '#185ABD', fontSize: '32px', padding:"4px" }}></i>:  "Puede cerrar esta ventana."}
              </span>
            </div>
          </div>
          
          }
          <div className="row">
            <div className="col-12 mt-2 pt-2 d-flex justify-content-center ">
            {path === '/payment' && <button
              className="btn custom-btn-icon-action pt-1 pb-1 ps-2 pe-2 me-3"
              type="button"
              disabled={isLoading}
              onClick={() =>
                handleDownload(formData)
                }>
                 { isLoading ?  " " :  "Descargar detalle "}
                  {isDownloadFile ? (
                    <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                    <i className="fas fa-download"></i>
                )}
              </button>}

               { !showIfrmae &&
               <>
                <button
                  onClick= { handleCancel}
                  disabled={isLoading || isLoadingPayment ||isDownloadFile }
                  className="btn custom-btn custom-cancel-btn ps-2 pe-2 me-3 "
                >
                <span><i className="fas fa-trash mx-1"></i>Cancelar</span>{ isLoading && <i className="fas fa-spinner fa-spin"></i>}
                </button>
                
               <button
                  className="btn custom-btn pt-1 pb-2 ps-3 pe-3"
                  onClick={handleSubmit}
                  disabled={isLoading || isLoadingPayment || isDownloadFile}
                >
                  
                     <span> Aceptar <i className="fas fa-angle-right"></i> </span> { isLoadingPayment && <i className="fas fa-spinner fa-spin"></i>}
                 
                </button>
               </>
                }

            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default PaymentModal;
PaymentModal.propTypes = {
  formData: PropTypes.object,
  paramsState: PropTypes.object,
  onSubmit: PropTypes.func,
  setOpenModalPayment: PropTypes.any,
  openModalPayment: PropTypes.bool,
  storedClass: PropTypes.any,
  path:PropTypes.string,
  downloadFileByPayment:PropTypes.func,
};
